export const OTHER_PRODUCTS_SELECT_PROPERTY_NAME = 'products';
